module.exports = __webpack_public_path__ + "img/cert_1.0af12a6d.jpg";